export class User {
  constructor(
    public id: string,
    public expiration: Date
  ) {}
}
